export default __webpack_public_path__ + "static/media/star-solid.ad83828c.svg";